export default __webpack_public_path__ + "static/media/class_x.39326e59.png";